module.exports = __webpack_public_path__ + "static/media/Monday_Step4_Image0.57ed185f.webp";